import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  AuthInterceptorModule,
  HttpsRequestInterceptor,
} from "./shared/guards/auth.interceptor";

import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import localePt from "@angular/common/locales/pt";
import { ReactiveFormsModule } from "@angular/forms";
import { MAT_DATE_LOCALE, MatIconModule } from "@angular/material";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ChartsModule } from "ng2-charts";
import { NgxSpinnerModule } from "ngx-spinner";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { DashboardModule } from "./modules/dashboard/dashboard.module";
import { HomeModule } from "./modules/home/home.module";
import { LoginModule } from "./modules/login/login.module";
import { ReportModule } from "./modules/report/report.module";
import { ServiceRequestModule } from "./modules/service-request/service-request.module";
import { UmovmeEnvironmentModule } from "./modules/umovme-environment/umovme-environment.module";
import { UpdateDatabaseModule } from "./modules/update-database/update-database.module";
import { SharedModule } from "./shared/shared.module";

registerLocaleData(localePt, "pt");

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule,
    SharedModule,
    LoginModule,
    HomeModule,
    ServiceRequestModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: "never" }),
    MatIconModule,
    AuthInterceptorModule,
    UpdateDatabaseModule,
    ReportModule,
    DashboardModule,
    UmovmeEnvironmentModule,
    ChartsModule,
  ],
  exports: [BrowserAnimationsModule],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
